import React from 'react';
import { useIntl } from 'react-intl';
import { useField } from 'react-final-form';
import { useFieldArray } from 'react-final-form-arrays';

import Label from 'types/Label';
import Card from 'components/ui/Card';

import QuestionType, { questionResponseProperty } from 'types/Question';
import FormKeys from 'modules/form/types/FormKeys';
import useLabelTranslation from 'hooks/useLabelTranslation';
import { isIntlMessage } from 'modules/notifications/types/Notification';

import QuestionCardActions from './QuestionCardActions';

interface QuestionFormProps {
  name: string;
  questionFilter?: (question: QuestionType) => boolean;
}

const Question: React.FC<QuestionFormProps> = ({ name, questionFilter }) => {
  const intl = useIntl();
  const { getLabelTranslation } = useLabelTranslation();

  const { input: { value: question }, meta } = useField<QuestionType>(name, {
    subscription: {
      value: true,
      error: true,
      submitFailed: true
    } });

  const error = meta.submitFailed && meta.error?.[questionResponseProperty[question.type]];


  const title = isIntlMessage(question.title)
    ? intl.formatMessage(question.title)
    : getLabelTranslation(question.title as Label);

  return (
    questionFilter(question) && (
      <li className="mb-5 last:mb-0">
        <Card {...question} centerText title={title} error={error}>
          <QuestionCardActions name={name} />
        </Card>
      </li>
    )
  );
};

const Questions: React.FC<{
  name: FormKeys;
  questionFilter?: (question: QuestionType) => boolean;
}> = ({ name, questionFilter = () => true }) => {
  const { fields: questions } = useFieldArray<QuestionType>(name, { subscription: {} });
  return (
    <ul>
      {questions.map((path: string) => (
        <Question key={path} name={path} questionFilter={questionFilter} />
      ))}
    </ul>
  );
};

export default Questions;
